import React from 'react';
import { motion } from 'framer-motion';
import { useTexts } from '../../hooks/useTexts';
import { useLanguage } from '../../contexts/LanguageContext';
import './Price.css';

/*
 * ============================================================
 *  PLANOS DE PREÇO — edite aqui seus valores
 * ============================================================
 */
const plans = {
  pt: [
    {
      id: 'basic',
      name: 'BÁSICO',
      price: 'Até R$ 350',
      period: '/projeto',
      desc: 'Ideal para vídeos curtos e criadores iniciando.',
      items: [
        'Até 8 minutos de vídeo final',
        'Corte e montagem',
        'Até 2 revisões',
      ],
      highlight: false,
    },
    {
      id: 'pro',
      name: 'PRO',
      price: 'Até R$ 750',
      period: '/projeto',
      desc: 'Para canais e marcas que querem qualidade cinematográfica.',
      items: [
        'Até 15 minutos de vídeo final',
        'Color grading avançado',
        'Motion graphics',
        'Sound design completo',
        'Até 4 revisões',
        'Thumbnail inclusa',
      ],
      highlight: true,
    },
    {
      id: 'gestao',
      name: 'GESTÃO',
      price: 'Sob consulta',
      period: '',
      desc: 'Projetos completos com direção e gestão audiovisual.',
      items: [
        'Pré-produção e briefing',
        'Coordenação de equipe',
        'Direção criativa',
        'Entregáveis ilimitados',
        'Suporte prioritário',
        'NDA disponível',
      ],
      highlight: false,
    },
  ],
  en: [
    {
      id: 'basic',
      name: 'BASIC',
      price: 'Up to $70',
      period: '/project',
      desc: 'Ideal for short videos and beginner creators.',
      items: [
        'Up to 8 minutes final video',
        'Cut and editing',
        'Up to 2 revisions',
      ],
      highlight: false,
    },
    {
      id: 'pro',
      name: 'PRO',
      price: 'Up to $150',
      period: '/project',
      desc: 'For channels and brands that want cinematic quality.',
      items: [
        'Up to 15 minutes final video',
        'Advanced color grading',
        'Motion graphics',
        'Full sound design',
        'Up to 4 revisions',
        'Thumbnail included',
      ],
      highlight: true,
    },
    {
      id: 'management',
      name: 'MANAGEMENT',
      price: 'Custom',
      period: '',
      desc: 'Full projects with audiovisual direction and management.',
      items: [
        'Pre-production & briefing',
        'Team coordination',
        'Creative direction',
        'Unlimited deliverables',
        'Priority support',
        'NDA available',
      ],
      highlight: false,
    },
  ],
};

export default function Price() {
  const { lang } = useLanguage();
  const currentPlans = plans[lang] || plans.pt;

  return (
    <section className="price-section" id="price">
      <div className="price-header">
        <p className="section-num">05 — {lang === 'pt' ? 'Investimento' : 'Pricing'}</p>
        <h2 className="section-title">
          {lang === 'pt' ? 'PLANOS' : 'PLANS'}<br />
          <span className="outline">{lang === 'pt' ? 'E PREÇOS' : '& PRICING'}</span>
        </h2>
      </div>

      <div className="price-grid">
        {currentPlans.map((plan, i) => (
          <motion.div
            key={plan.id}
            className={`price-card ${plan.highlight ? 'price-card--highlight' : ''}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.12 }}
          >
            {plan.highlight && (
              <div className="price-badge">
                {lang === 'pt' ? 'Mais popular' : 'Most popular'}
              </div>
            )}
            <div className="price-name">{plan.name}</div>
            <div className="price-value">
              {plan.price}
              {plan.period && <span className="price-period">{plan.period}</span>}
            </div>
            <p className="price-desc">{plan.desc}</p>
            <ul className="price-items">
              {plan.items.map(item => (
                <li key={item}>
                  <span className="price-check">✓</span>
                  {item}
                </li>
              ))}
            </ul>
            <a href="#contact" className={`price-btn ${plan.highlight ? 'price-btn--accent' : ''}`}>
              {lang === 'pt' ? 'Contratar' : 'Get started'} →
            </a>
          </motion.div>
        ))}
    </div>
    </section>
  );
}
